import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaUserCircle, FaKey, FaLaptop, FaHistory, FaEnvelope, FaSignOutAlt, FaChevronDown } from 'react-icons/fa';
import { useAuth } from './AuthContext'; // <-- 1. Import our hook

export default function AccountInfo() {
    // --- FIX APPLIED: Get user and logout function directly from the context ---
    const { user, logoutUser } = useAuth(); 
    
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // --- FIX APPLIED: The entire useEffect for fetching user data is no longer needed and has been removed. ---
    // The 'user' object from useAuth is our single source of truth.

    // Close dropdown when clicking outside (this logic is correct and remains)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // --- FIX APPLIED: The logout handler now calls the correct function from our context ---
    const handleLogout = () => {
        logoutUser(); // This handles the API call, state clearing, and navigation
    };

    return (
        <div className="account-info-container" ref={dropdownRef}>
            <button className="account-info-button" onClick={() => setIsOpen(!isOpen)}>
                <FaUserCircle className="account-avatar-icon" />
                <div className="account-user-details">
                    {/* The user object now comes directly from the context */}
                    <span className="account-user-name">{user ? user.username : 'Loading...'}</span>
                    <span className="account-user-role">{user ? user.role : '...'}</span>
                </div>
                <FaChevronDown className={`account-chevron ${isOpen ? 'open' : ''}`} />
            </button>

            {isOpen && (
                <div className="account-dropdown-menu">
                    <ul>
                        <li>
                            <Link to="/change-password">
                                <FaKey /> Change Password
                            </Link>
                        </li>
                        <li>
                            <Link to="/connected-devices">
                                <FaLaptop /> Connected Devices
                            </Link>
                        </li>
                        <li>
                            <Link to="/login-history">
                                <FaHistory /> Login History
                            </Link>
                        </li>
                        <li>
                            <Link to="/email-preferences">
                                <FaEnvelope /> Email Preferences
                            </Link>
                        </li>
                        <li className="separator"></li>
                        <li>
                            <button onClick={handleLogout}>
                                <FaSignOutAlt /> Log out
                            </button>
                        </li>
                    </ul>
                </div>
            )}
            
            <style>{`
                /* Your existing CSS styles are correct and remain here */
                :root { --dark-bg: #1a202c; --card-bg: #2d3748; --text-color: #e2e8f0; --light-text: #a0aec0; --green-accent: #48bb78; --border-color: #4a5568; }
                .account-info-container { position: relative; z-index: 50; }
                .account-info-button { display: flex; align-items: center; gap: 0.75rem; background-color: transparent; border: none; border-radius: 8px; padding: 0.5rem; cursor: pointer; transition: background-color 0.2s ease-in-out; }
                .account-info-button:hover { background-color: var(--border-color); }
                .account-avatar-icon { font-size: 40px; color: var(--green-accent); flex-shrink: 0; }
                .account-user-details { display: flex; flex-direction: column; align-items: flex-start; text-align: left; }
                .account-user-name { font-weight: 600; color: var(--text-color); font-size: 0.9rem; }
                .account-user-role { font-size: 0.75rem; color: var(--light-text); text-transform: capitalize; }
                .account-chevron { color: var(--light-text); transition: transform 0.2s ease-in-out; }
                .account-chevron.open { transform: rotate(180deg); }
                .account-dropdown-menu { position: absolute; top: calc(100% + 10px); right: 0; width: 220px; background-color: var(--card-bg); border: 1px solid var(--border-color); border-radius: 8px; box-shadow: 0 10px 20px rgba(0,0,0,0.3); overflow: hidden; animation: fadeIn 0.2s ease-out; }
                .account-dropdown-menu ul { list-style: none; padding: 0.5rem 0; margin: 0; }
                .account-dropdown-menu li a, .account-dropdown-menu li button { display: flex; align-items: center; gap: 0.75rem; padding: 0.75rem 1rem; color: var(--text-color); text-decoration: none; font-size: 0.9rem; transition: background-color 0.2s; width: 100%; text-align: left; background: none; border: none; cursor: pointer; }
                .account-dropdown-menu li a:hover, .account-dropdown-menu li button:hover { background-color: var(--border-color); }
                .account-dropdown-menu .separator { height: 1px; background-color: var(--border-color); margin: 0.5rem 0; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}